export const SET_MODIFIER_SETTINGS_DATA_LOADING = 'SET_MODIFIER_SETTINGS_DATA_LOADING';
export const SET_MODIFIER_SETTINGS_DATA = 'SET_MODIFIER_SETTINGS_DATA';
